<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->
  
<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

var breadcrumb_separator=`<span class="separate" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></span>`;
var addition_brdcrmb='';
var haColinArr=false;
if(page__handle!=""){
  eraseCookie_cstm();
}else if(coll_handle!="" ){
       var cl_data =coll_handle+"@"+coll_title;
      createCookie('coll_value',cl_data,1);
}else if(!jQuery('body').hasClass('template-product') && !jQuery('body').hasClass('template-collection') ){
    eraseCookie_cstm();
}
coll_value=readCookie('coll_value');
store_value=readCookie('store_value');

// if(coll_handle!=""){
//    var category_sidebar_show=false;
//         jQuery('.navPage-parent-item').each(function(i, obj) {
//               var $this=jQuery(this);
//              $this.hide();
//              if($this.attr("data-handle")==coll_handle){
//                category_sidebar_show=true;
//                 $this.show();
//              } 
//              else if(jQuery(".current-cate",$this).length !=0 )
//              {
//                category_sidebar_show=true;
//                 $this.show(); 
//                $this.trigger("click");
//                 $('.page_productlist_main .sidebar-categories').show();
//              }
//           });
//     if(!category_sidebar_show){
//       $('.page_productlist_main .sidebar-categories').hide(); 
//     }
//   }

$(document).ready(function() {
    $('.acc-head').on('click', function() {
        if($(this).hasClass('active')) {
          $(this).siblings('.acc-content').slideUp();
          $(this).removeClass('active');
        }
        else {
          $('.acc-content').slideUp();
          $('.acc-head').removeClass('active');
          $(this).siblings('.acc-content').slideToggle();
          $(this).toggleClass('active');
        }
    });     

   // tooltip
     $('.tooltip-trigger').hover(
    function() {
      const tooltip = $(this).next('.tooltip');
      tooltip.css({ visibility: 'visible', opacity: '1' });
    },
    function() {
      const tooltip = $(this).next('.tooltip');
      tooltip.css({ visibility: 'hidden', opacity: '0' });
    }
  );
});
$(document).ready(function() {
  $('.instagram-special').slick({
     slidesToShow: 6,
     slidesToScroll: 1,
     autoplay: true,
     autoplaySpeed: 2000,
     responsive: [
        {
           breakpoint: 767,
           settings: {
     slidesToShow: 3,
     slidesToScroll: 1,
           }
        },
        {
           breakpoint: 425,
           settings: {
     slidesToShow: 1,
     slidesToScroll: 1,
           }
        }
     ]
  });




/*==========collection page category filter current page options  ==========*/
 if(coll_handle!=""){
   var category_sidebar_show=false;
        jQuery('.navPage-parent-item').each(function(i, obj) {
              var $this=jQuery(this);
             
             if($this.attr("data-handle")==coll_handle){
               category_sidebar_show=true;
                $this.show();
             } 
             else if(jQuery(".current-cate",$this).length !=0 )
             {
               category_sidebar_show=true;
                $this.show(); 
              // $this.trigger("click");
             }else{
               $this.hide();
             }
          });
    if(!category_sidebar_show){
      $('.page_productlist_main .sidebar-categories').hide(); 
    }
  }


  
  /*==========make breadcrumb dynamic of store // collection // product page  ==========*/
   $('.cm__multiple_category_box .view-more-content').on('click auxclick contextmenu', function(e) {
        e.preventDefault();
        var cl_handle=jQuery(this).attr("data-handle");
        var cl_title=jQuery(this).attr("data-title");
        var cl_data =cl_handle+"@"+cl_title;
        var str_data = page__handle+"@"+page__title;
        createCookie('coll_value',cl_data,1);
        createCookie('store_value',str_data,1);
        if (e.which == 2) {
          window.open(jQuery(this).attr("href"), '_blank');
        }else{
          window.location.href=jQuery(this).attr("href");
        }
        return true;
     }); 
    
    if(store_value!=null){
        var brdobj =store_value.split("@");
           addition_brdcrmb+=breadcrumb_separator+`<span class="bd-title"><span><a href="/pages/`+brdobj[0]+`" title="">`+brdobj[1]+`</a></span></span>`;
    }


  
    /*==========implement breadcrumb in product page and collection page START  ==========*/
  if(coll_value!=null && product_collections !=null && jQuery('body').hasClass('template-product') ){
    var brdobj = coll_value.split("@");
    productCollectionsArray = product_collections.split(",");
     for(var c=0; c < productCollectionsArray.length; c++){
       if(productCollectionsArray[c]==brdobj[0]){
         haColinArr=true;
       }
     }
    addition_brdcrmb+=breadcrumb_separator+`<span class="bd-title"><span><a href="/collections/`+brdobj[0]+`" title="">`+brdobj[1]+`</a></span></span>`;
  }
  
  if(addition_brdcrmb!="" && jQuery('body').hasClass('template-product') ){
    jQuery(".cm_brd_crmbs_add_links").html(addition_brdcrmb);
        jQuery(".cm_brd_crmbs_add_links").css({ "display": "flex" });

  }else if(addition_brdcrmb!="" && jQuery('body').hasClass('template-collection') ){
   jQuery(".cm_brd_crmbs_add_links").html(addition_brdcrmb);
    jQuery(".cm_brd_crmbs_add_links").css({ "display": "flex" });
  }
      /*==========implement breadcrumb in product page and collection page END  ==========*/

 }); 



//Create Cookie
  function createCookie(name, value, days) {
       var expires;
       if (days) {
           var date = new Date();
           date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
           expires = "; expires=" + date.toGMTString();
       } else {
           expires = "";
       }
       document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
   }

//Read Cookie
   function readCookie(name) {
       var nameEQ = encodeURIComponent(name) + "=";
       var ca = document.cookie.split(';');
       for (var i = 0; i < ca.length; i++) {
           var c = ca[i];
           while (c.charAt(0) === ' ')
               c = c.substring(1, c.length);
           if (c.indexOf(nameEQ) === 0)
               return decodeURIComponent(c.substring(nameEQ.length, c.length));
       }
       return null;
   }

//Remove Cookie
   function eraseCookie(name) {
       createCookie(name, "", -1);
   }


 function eraseCookie_cstm(){
   eraseCookie('store_value') 
   eraseCookie('coll_value') 
 }


//Testimonial content change custom
function pageslidecontentshow(){
  if(jQuery(".brand-slider-has-content .slick-current.slick-active").length){
    var maincontent=jQuery(".brand-slider-has-content .slick-current.slick-active").attr("data-id");
    jQuery(".tm_blocks").removeClass("active");
    jQuery(".tm_blocks[data-id='"+maincontent+"']").addClass("active");
  }
}

//04-01-2023 buy now button Custom
function instantBuy(){
     var $ = jQuery;

   var formParams = $('form.cart').serialize();
     $.ajax({
      url: "/cart/add",
      type: "post",
      data: formParams,
      success: function(){ 
       window.location.href = "/checkout";
      },
      error: function(){
      }
     })
 }


/* Code bkup
$(document).ready(function() {
  if ($('.page_product_single_main').length) {
 
  
  console.log('Single product pagwe');
 setInterval(function() {
    if ($('button.sbb').length) {
      console.log('Single page sbb');
   }
 var btn = $('#product-add-to-cart').val() || $('#product-add-to-cart').text();
 //  console.log("btn value "+btn);
  var data_txt = $('#backorder_description').data('txt');

  if ( btn == 'Back Order') {
  //  var dataTxt = $('#backorder_description').data('txt');
    console.log("Data TXt: "+data_txt);
   // $('.backorder_description').text(data_txt);
  } else if(btn == 'Preorder Now'){
     console.log('pre order');
   // $('.backorder_description').text('');
  } else{
     //$('.backorder_description').text(data_txt);
    console.log("product is niether backorder nor preorder ");
  }
   
 }, 300);
};
  $('input[name="Size"]').on('change',function() {
   //  $('.backorder_description').text('');
   var $buttonContainer = $('.button-container');
   
    $buttonContainer.addClass('loading');

    setTimeout(function() {
      $buttonContainer.removeClass('loading');
    }, 2000); // Change the delay time as needed
  
    
  });
  

});

*/

// For Backorder Functionality 
 if ($('.page_product_single_main').length) {
   $(window).on('load', function() {
      
     let productbtnAppcheck= setInterval(function(){
       if($('[class*="pn-button-"]').length!=0){
        $('[class*="pn-button-"]').removeClass('is-loading');
        
        clearInterval(productbtnAppcheck);
       }
      
     },300);
      $('.product-form__radio').on('change',function() {
       //  $('.backorder_description').text('');
       
        $('[class*="pn-button-"]').addClass('is-loading');
      
        setTimeout(function() {
            $('[class*="pn-button-"]').removeClass('is-loading');
          
        }, 1000); // Change the delay time as needed
      
        
      });
    });
 }
